import { Component, OnInit, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { IomService } from 'src/app/services/iom.service';
import { HttpErrorResponse } from '@angular/common/http';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { timeout } from 'rxjs/operators';
declare var bootbox: any;
declare var $: any;

@Component({
  selector: 'app-add-insights',
  templateUrl: './add-insights.component.html',
  styleUrls: ['./add-insights.component.css']
})
export class AddInsightsComponent implements OnInit, AfterViewInit {

  VersionId: string;
  RowRanking: number;
  InsightTitle: string;
  public lstChartType = [];
  public lstAxis = [];
  public lstLegend = [];
  public lstDataValue = [];
  public lstInsight = [];
  public lstInsightOverall = [];
  subject = new Subject();


  selectedChartType: string;
  selectedAxis: string;
  selectedLegend: string;
  selectedValue: string;

  ChartHeading: string;
  Observation: string;

  dropdownList = [];
  selectedItems = [];
  dropdownSettings: IDropdownSettings = {};
  graphData: any;
  graphData1: any;
  masterKey: any;
  masterDataForEdit: any;
  IsOverAll: boolean = false;
  isEdited: boolean = false;
  enableApplyButton = true;
  loadChart: boolean = false;
  disableLegend: boolean = false;
  disableCategory: boolean = false;
  getPrevChartDetails = [];
  @Output() editInsightsEmitter = new EventEmitter();
  constructor(public iomService: IomService, private spinner: NgxSpinnerService) {
    this.selectedItems = [
      { CategoryId: 0, CategoryName: 'Automation Opportunities' }
    ];
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'CategoryId',
      textField: 'CategoryName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: false
    };
  }

  ngOnInit(): void {
    this.getPrevChartDetails = [];
    this.VersionId = this.iomService.versionID;
    this.RowRanking = this.iomService.rowRanking;
    if (this.iomService.categoryName != "" && this.iomService.categoryName != undefined) {
      this.selectedItems = [
        { CategoryId: this.iomService.categoryId, CategoryName: this.iomService.categoryName }
      ];
    }
    this.selectedChartType = "Select";
    this.selectedAxis = "Select";
    this.selectedLegend = "Select";
    this.selectedValue = "Select";
    this.IsOverAll = this.iomService.isOverAll;
    this.graphData = {};
    this.spinner.show();
    this.iomService.LoadAddEditCharts<any>(this.VersionId, this.RowRanking, this.iomService.categoryId, this.iomService.subCategoryID).subscribe(data => {
      this.lstChartType = data.ChartTypeList.filter(Boolean);
      this.lstAxis = data.AxisList.filter(Boolean);
      this.lstLegend = data.LegendList.filter(Boolean);
      this.lstDataValue = data.ValueList.filter(Boolean);
      this.lstInsight = data.SectionList.filter(Boolean);
      this.InsightTitle = "Add Insights";
      if (this.RowRanking != null) {
        this.graphData = this.GetChartObjectbyRowRank(this.RowRanking);
        // this.masterDataForEdit = this.GetMasterDataForEdit(this.RowRanking).split(':|:');
        this.isEdited = true;       
        setTimeout(() => {
          this.loadChart = true;
          this.spinner.hide();
        }, 2000); 
        this.InsightTitle = "Edit Insights";
        // this.selectedChartType = this.masterDataForEdit[3];
        // this.selectedAxis = this.masterDataForEdit[0];
        // this.selectedLegend = this.masterDataForEdit[2];
        // this.selectedValue = this.masterDataForEdit[4];
        this.selectedChartType = this.lstChartType[0];
        this.selectedAxis = this.lstAxis[0];
        this.selectedLegend = this.lstLegend[0];
        this.selectedValue = this.lstDataValue[0];
        this.disableLegendAndSwapLoad(this.selectedChartType);
        this.ChartHeading = this.iomService.chartTitle;
        this.Observation = this.iomService.observation;

        this.getPrevChartDetails.push({
          selectedChartType: this.lstChartType[0],
          selectedAxis: this.lstAxis[0],
          selectedLegend: this.lstLegend[0],
          selectedValue: this.lstDataValue[0]
        })
      } else {
        this.loadChart = false;
        this.spinner.hide();
      }      
    },
      (err: HttpErrorResponse) => {
        this.spinner.hide();
      });
  }
  disableLegendAndSwap(event: any) {
    let text = event.currentTarget.value;
    this.enableApplyButton = true;
    // tslint:disable-next-line: max-line-length
    if (text.trim().toLowerCase().indexOf('map') > -1 || text.trim().toLowerCase().indexOf('combo') > -1 || text.trim().toLowerCase().indexOf('tacked') > -1 || text.trim().toLowerCase().indexOf('area') > -1) {
      this.disableLegend = false;
      this.lstLegend = this.lstLegend.filter(item => item != 'TicketCount').filter(item => item != 'TicketAge');
      //if (!this.isEdited) {
      this.selectedLegend = 'Select';
      //}
      $('#ddlLegend').css({ 'cursor': '' });
    }
    else {
      $('#ddlLegend').css({ 'cursor': 'not-allowed' });
      this.selectedLegend = 'Select';
      this.disableLegend = true;
    }
    //this.disableCategory = false;
    //$('#ddlCategory').css({ 'cursor': '' });
  }
  disableLegendAndSwapLoad(event: any) {
    let text = event;
    // tslint:disable-next-line: max-line-length
    if (text.trim().toLowerCase().indexOf('map') > -1 || text.trim().toLowerCase().indexOf('combo') > -1 || text.trim().toLowerCase().indexOf('tacked') > -1 || text.trim().toLowerCase().indexOf('area') > -1) {
      this.disableLegend = false;
      this.lstLegend = this.lstLegend.filter(item => item != 'TicketCount').filter(item => item != 'TicketAge');
      // this.selectedLegend = 'Select';   
      $('#ddlLegend').css({ 'cursor': '' });
    }
    else {
      $('#ddlLegend').css({ 'cursor': 'not-allowed' });
      this.selectedLegend = 'Select';
      this.disableLegend = true;
      // this.selectedLegend = 'Select';
    }
    //this.disableCategory = true;
    //$('#ddlCategory').css({ 'cursor': 'not-allowed' });    
  }
  ngAfterViewInit() {
    // let element: HTMLElement = document.getElementById('btnPreviewPanel') as HTMLElement;
    // element.click(); 
  }
  ngAfterViewChecked() {
    this.DefaultSectioncheckin();
    this.defaultsection();
  }
  selectAllCategory() {
    if ($('.selectAllCategory').prop('checked') == true) {
      $('#categoryTree').find('.form-check-input').each(function () {
        $(this).prop("checked", true);
      });
    }
    else {
      $('#categoryTree').find('.form-check-input').each(function () {
        $(this).prop("checked", false);
      });
    }
  }
  checkSelectedCategory() {
    if ($('.checkCategory:checked').length == $('.checkCategory').length) {
      $(' .selectAllCategory').prop('checked', true);
    }
    else {
      $('.selectAllCategory').prop('checked', false);
    }
  }
  DefaultSectioncheckin() {
    var catId = this.iomService.categoryId;
    $(".checkCategory").each(function () {
      if (this.value.split('^')[0] == 0) {
        $(this).prop("checked", true);
        $(this).prop("disabled", true);
      }
      if (this.value.split('^')[0] == catId) {
        $(this).prop("checked", true);
      }

    });
  }
  defaultsection() {
    var checkedsection = '';
    var allbenefits = $('.selectSections');
    checkedsection = '';
    var count = 0;
    $.each(allbenefits.find('.checkCategory'), function (index, value) {
      if (value.checked) {
        count++;
        if (count == 1)
          checkedsection += value.parentNode.innerText + "";
      }
    })
    if (count > 1)
      checkedsection = checkedsection + "...";
    checkedsection = checkedsection.substring(0, checkedsection.length - 1);
    if (checkedsection != '')
      $('#ddlSection').text(checkedsection);
    else
      $('#ddlSection').text(' ');
  }
  GetChartObjectbyRowRank(RowRanking: number) {
    if (this.IsOverAll == false) {
      let obj = [];
      $.each(this.iomService.graphData, function (key, chartObj) {
        $.each(chartObj, function (key, innerObj) {
          if (key.indexOf(':|:' + RowRanking + ':|:') > -1) {
            if (obj.length == 0) {
              obj.push(chartObj);
            }
            //obj = chartObj;
          }
        });
      });
      return obj;
    }
    else {
      let obj = {};
      $.each(this.iomService.graphData, function (key, chartObj) {
        if (key.indexOf(':|:' + RowRanking + ':|:') > -1) {
          obj = { [key]: chartObj };
        }
      });
      return obj;
    }
  }
  GetMasterDataForEdit(RowRanking: number) {
    var obj;
    if (this.IsOverAll == false) {
      $.each(this.iomService.graphData, function (key, chartObj) {
        $.each(chartObj, function (key, innerObj) {
          if (key.indexOf(':|:' + RowRanking + ':|:') > -1) {
            obj = key;
          }
        });
      });
    }
    else {
      $.each(this.iomService.graphData, function (key, chartObj) {
        if (key.indexOf(':|:' + RowRanking + ':|:') > -1) {
          obj = key;
        }
      });
    }
    return obj;
  }
  switchAxisLegend() {
    let curAxis = this.selectedAxis;
    this.selectedAxis = this.selectedLegend;
    this.selectedLegend = curAxis;
  }

  previeworApplyCharts(isAdd, isApply) {
    if (this.Validation()) {
      var previewRequest = [];
      this.lstInsightOverall = [];
      let isCategory;
      let finalInsightList = [];
      let section: number;
      if (this.iomService.isOverAll == true) {
        section = 1;
        isCategory = false;
      }
      else if (this.iomService.isOverAll == false && this.iomService.subCategoryID != '' && this.iomService.subCategoryID != null) {
        section = 3;
        isCategory = false;
      }
      else {
        section = 2;
        isCategory = true;
      }
      let element: { Id: number, ChartType: string, Axis: string, Legend: string, Value: string, VersionId: string, IsAdd: boolean, IsApply: boolean, RowRanking: number, Section: number, IsOverAll: boolean, Observation: string, CategoryName: string, CategoryId, SubCategoryId, IsCategory: boolean, IsDeleted:  number };
      //let elementZ: { Id: number, ChartType: string, Axis: string, Legend: string, Value: string, VersionId: string, IsAdd: boolean, IsApply: boolean, RowRanking: number, Section: number, IsOverAll: boolean, Observation: string, CategoryName: string, CategoryId, SubCategoryId, IsCategory: boolean };
      //var index = 0;
      var current = this;
      if (this.lstInsight != null && this.lstInsight.length > 0) {
        this.lstInsight = this.lstInsight.filter(x => x.CategoryName != "Automation Opportunities");
        let legend;
        if (current.disableLegend == false || current.selectedChartType.trim().toLowerCase().indexOf('combo') > -1) {
          legend = current.selectedLegend.trim();
        }
        if (!isApply) {
          this.lstInsightOverall.push(this.lstInsight[0]);
          finalInsightList = this.lstInsightOverall;
        }
        else {
          finalInsightList = this.lstInsight;
          // Overall record
          element = {
            Id: -1,
            ChartType: current.selectedChartType.trim(),
            Axis: current.selectedAxis.trim(),
            Legend: legend,
            Value: current.selectedValue.trim(),
            VersionId: current.iomService.versionID,
            IsAdd: isAdd,
            IsApply: isApply,
            RowRanking: current.iomService.rowRanking,
            IsOverAll: current.iomService.isOverAll,
            Observation: current.Observation,
            CategoryName: "Automation Opportunities",
            CategoryId: null,
            SubCategoryId: null,
            IsCategory: isCategory,
            Section: section,
            IsDeleted: null
          };
          previewRequest.push(element);  
        }
        finalInsightList.forEach((x, i) => {
          //category level record
          element = {
            Id: i,
            ChartType: current.selectedChartType.trim(),
            Axis: current.selectedAxis.trim(),
            Legend: legend,
            Value: current.selectedValue.trim(),
            VersionId: current.iomService.versionID,
            IsAdd: isAdd,
            IsApply: isApply,
            RowRanking: current.iomService.rowRanking,
            IsOverAll: current.iomService.isOverAll,
            Observation: current.Observation,
            CategoryName: x.CategoryName,
            CategoryId: (current.iomService.isOverAll && !isApply) ? null : (isApply ? x.CatgoryID : current.iomService.categoryId),
            SubCategoryId: (current.iomService.isOverAll && !isApply) ? null : current.iomService.subCategoryID,
            IsCategory: isCategory,
            Section: section,
            IsDeleted: null
          };
          previewRequest.push(element);  
          //index = index + 1;
        });

        this.getPrevChartDetails.forEach((x, i) => {
          //category level record
          element = {
            Id: i,
            ChartType: x.selectedChartType.trim(),
            Axis: x.selectedAxis.trim(),
            Legend: x.legend,
            Value: x.selectedValue.trim(),
            VersionId: current.iomService.versionID,
            IsAdd: isAdd,
            IsApply: isApply,
            RowRanking: current.iomService.rowRanking,
            IsOverAll: current.iomService.isOverAll,
            Observation: current.Observation,
            CategoryName: x.CategoryName,
            CategoryId: (current.iomService.isOverAll && !isApply) ? null : (isApply ? x.CatgoryID : current.iomService.categoryId),
            SubCategoryId: (current.iomService.isOverAll && !isApply) ? null : current.iomService.subCategoryID,
            IsCategory: isCategory,
            Section: section,
            IsDeleted: 1
          };
          previewRequest.push(element);  
          //index = index + 1;
        });
        // if (current.iomService.isOverAll) {
        //   element.Id = i;
        //   element.CategoryId = this.lstInsight[0].CatgoryID;
        //   previewRequest.push(element);
        // }
      }
      this.spinner.show();
      this.loadChart = false;
      this.iomService.PrevieworApplyCharts<any>(previewRequest).pipe(timeout(2400000)).subscribe(response => {
        this.spinner.hide();
        if (this.iomService.isOverAll == true) {
          if (isApply) {
            if (response.IsDuplicate) {
              bootbox.alert("The insight already exists");
              this.selectedChartType = 'Select';
                  this.selectedAxis = 'Select';
                  this.selectedLegend = 'Select';
                  this.selectedValue = 'Select';
                  this.ChartHeading = '';
                  this.Observation = '';
            }
            else {
              if (response.Result != 'Failure') {
                if (this.isEdited != true) {
                  bootbox.alert("The insight added successfully");
                  this.selectedChartType = 'Select';
                  this.selectedAxis = 'Select';
                  this.selectedLegend = 'Select';
                  this.selectedValue = 'Select';
                  this.ChartHeading = '';
                  this.Observation = '';
                }
                else {
                  bootbox.alert("The insight edited successfully");
                }
                this.closedInsights();
                this.editInsightsEmitter.emit();
              }
              else {
                bootbox.alert("Error occured");
              }
            }
          }
          else {
            if (response != null) {
              if (response.SeverityData != null) {
                this.LoadCharts(response.SeverityData);
                this.loadChart = true;
                if (response.ChartHeading != null && response.ChartHeading != undefined) {
                  this.ChartHeading = response.ChartHeading;
                }
                if (response.Observation != null && response.Observation != undefined) {
                  this.Observation = response.Observation;
                }
                this.enableApplyButton = false;
              }
              else {
                bootbox.alert("There is no ticket for the insight");
              }
            }
            else {
              bootbox.alert("There is no ticket for the insight");
            }
          }
        }
        else {
          if (isApply) {
            if (response.IsDuplicate) {
              bootbox.alert("The insight already exists");
              this.selectedChartType = 'Select';
                  this.selectedAxis = 'Select';
                  this.selectedLegend = 'Select';
                  this.selectedValue = 'Select';
                  this.ChartHeading = '';
                  this.Observation = '';
            }
            else {
              if (response.Result != 'Failure') {
                if (this.isEdited != true) {
                  bootbox.alert("The insight added successfully");
                  this.selectedChartType = 'Select';
                  this.selectedAxis = 'Select';
                  this.selectedLegend = 'Select';
                  this.selectedValue = 'Select';
                  this.ChartHeading = '';
                  this.Observation = '';
                }
                else {
                  bootbox.alert("The insight edited successfully");
                }
                this.closedInsights();
                this.editInsightsEmitter.emit();
              }

              else {
                bootbox.alert("Error occured");
              }
            }
          }
          else {
            if (response != null) {
              if (response.ChartObjectCategoryandSubCategoryLevel != null && !($.isEmptyObject(response.ChartObjectCategoryandSubCategoryLevel))) {
                this.LoadCharts(response.ChartObjectCategoryandSubCategoryLevel);
                this.loadChart = true;
                if (response.ChartHeading != null && response.ChartHeading != undefined) {
                  this.ChartHeading = response.ChartHeading;
                }
                if (response.Observation != null && response.Observation != undefined) {
                  this.Observation = response.Observation;
                }
                this.enableApplyButton = false;
              }
              else {
                bootbox.alert("There is no ticket for the insight");
              }
            }
            else {
              bootbox.alert("There is no ticket for the insight");
            }
          }
        }
      },
        (err: HttpErrorResponse) => {
          this.spinner.hide();
          if (err.message != "Timeout has occurred") {
            bootbox.alert("Server Error!");
          }
        });
    }
  }




  LoadCharts(data) {
    //var data = { "SeverityData": { "SLA:|:2:|:ProblemAreas:|:Stacked Column:|:TicketCount": [{ "X": 0, "Y": 0, "Data": 792, "ChartType": "Stacked Column", "CategoryName": "Standalone_BOM1", "xAxisCategories": ["Met", "Missed", "Breached"], "yAxisCategories": ["Standalone_BOM1"], "sankeyFromdata": ["Met", "Missed", "Breached"], "sankeyTodata": ["Standalone_BOM1", "Standalone_BOM1", "Standalone_BOM1"], "sankeyData": [792, 720, 288], "comboTicketcount": ["Standalone_BOM1", "Standalone_BOM1", "Standalone_BOM1"], "Value": "TicketCount" }, { "X": 1, "Y": 0, "Data": 720, "ChartType": "Stacked Column", "CategoryName": "Standalone_BOM1", "xAxisCategories": null, "yAxisCategories": null, "sankeyFromdata": null, "sankeyTodata": null, "sankeyData": null, "comboTicketcount": null, "Value": "TicketCount" }, { "X": 2, "Y": 0, "Data": 288, "ChartType": "Stacked Column", "CategoryName": "Standalone_BOM1", "xAxisCategories": null, "yAxisCategories": null, "sankeyFromdata": null, "sankeyTodata": null, "sankeyData": null, "comboTicketcount": null, "Value": "TicketCount" }], "ApplicationName:|:1:|:ProblemAreas:|:Stacked Column:|:TicketCount": [{ "X": 0, "Y": 0, "Data": 540, "ChartType": "Stacked Column", "CategoryName": "Standalone_BOM1", "xAxisCategories": ["App1", "App2", "App3", "App4"], "yAxisCategories": ["Standalone_BOM1"], "sankeyFromdata": ["App1", "App2", "App3", "App4"], "sankeyTodata": ["Standalone_BOM1", "Standalone_BOM1", "Standalone_BOM1", "Standalone_BOM1"], "sankeyData": [540, 540, 360, 360], "comboTicketcount": ["Standalone_BOM1", "Standalone_BOM1", "Standalone_BOM1", "Standalone_BOM1"], "Value": "TicketCount" }, { "X": 1, "Y": 0, "Data": 540, "ChartType": "Stacked Column", "CategoryName": "Standalone_BOM1", "xAxisCategories": null, "yAxisCategories": null, "sankeyFromdata": null, "sankeyTodata": null, "sankeyData": null, "comboTicketcount": null, "Value": "TicketCount" }, { "X": 2, "Y": 0, "Data": 360, "ChartType": "Stacked Column", "CategoryName": "Standalone_BOM1", "xAxisCategories": null, "yAxisCategories": null, "sankeyFromdata": null, "sankeyTodata": null, "sankeyData": null, "comboTicketcount": null, "Value": "TicketCount" }, { "X": 3, "Y": 0, "Data": 360, "ChartType": "Stacked Column", "CategoryName": "Standalone_BOM1", "xAxisCategories": null, "yAxisCategories": null, "sankeyFromdata": null, "sankeyTodata": null, "sankeyData": null, "comboTicketcount": null, "Value": "TicketCount" }], "Technology:|:3:|:ProblemAreas:|:Stacked Column:|:TicketCount": [{ "X": 0, "Y": 0, "Data": 504, "ChartType": "Stacked Column", "CategoryName": "Standalone_BOM1", "xAxisCategories": ["Tech1", "Tech2", "Tech3", "Tech4"], "yAxisCategories": ["Standalone_BOM1"], "sankeyFromdata": ["Tech1", "Tech2", "Tech3", "Tech4"], "sankeyTodata": ["Standalone_BOM1", "Standalone_BOM1", "Standalone_BOM1", "Standalone_BOM1"], "sankeyData": [504, 504, 468, 324], "comboTicketcount": ["Standalone_BOM1", "Standalone_BOM1", "Standalone_BOM1", "Standalone_BOM1"], "Value": "TicketCount" }, { "X": 1, "Y": 0, "Data": 504, "ChartType": "Stacked Column", "CategoryName": "Standalone_BOM1", "xAxisCategories": null, "yAxisCategories": null, "sankeyFromdata": null, "sankeyTodata": null, "sankeyData": null, "comboTicketcount": null, "Value": "TicketCount" }, { "X": 2, "Y": 0, "Data": 468, "ChartType": "Stacked Column", "CategoryName": "Standalone_BOM1", "xAxisCategories": null, "yAxisCategories": null, "sankeyFromdata": null, "sankeyTodata": null, "sankeyData": null, "comboTicketcount": null, "Value": "TicketCount" }, { "X": 3, "Y": 0, "Data": 324, "ChartType": "Stacked Column", "CategoryName": "Standalone_BOM1", "xAxisCategories": null, "yAxisCategories": null, "sankeyFromdata": null, "sankeyTodata": null, "sankeyData": null, "comboTicketcount": null, "Value": "TicketCount" }], "ProblemAreas:|:4:|:TicketCount:|:Combo:|:TicketAge": [{ "X": 0, "Y": 0, "Data": 2, "ChartType": "Combo", "CategoryName": "1800", "xAxisCategories": ["Standalone_BOM1"], "yAxisCategories": ["1800"], "sankeyFromdata": ["Standalone_BOM1"], "sankeyTodata": ["1800"], "sankeyData": [2], "comboTicketcount": ["1800"], "Value": "TicketAge" }] }, "viewChartResponse": [{ "ChartHeading": "ApplicationName by Top ProblemAreas", "RowRanking": 1, "IsEnabled": true }, { "ChartHeading": "Avg Duration by Top ProblemAreas", "RowRanking": 4, "IsEnabled": true }, { "ChartHeading": "SLA by Top ProblemAreas", "RowRanking": 2, "IsEnabled": true }, { "ChartHeading": "Technology by Top ProblemAreas", "RowRanking": 3, "IsEnabled": true }], "ChartObjectCategoryandSubCategoryLevel": null, "IsDuplicate": false, "Result": null, "ChartHeading": null, "Observation": null, "ReturnCode": 0, "ErrorXml": null, "Faults": null, "Fault": null };
    this.graphData = data;
    if (this.iomService.isOverAll == true) {
      this.IsOverAll = true;
    }
  }
  GetRowRank(key): number {
    if (!this.IsOverAll) {
      key = Object.keys(this.graphData[key])[0];
    }
    return (key.indexOf(':|:') > -1 ? key.split(':|:')[1] : 0);
  }
  closedInsights() {
    this.iomService.isLoadInsight = false;
    this.loadChart = false;
  }
  Validation() {
    var chartType = this.selectedChartType.trim().toLowerCase();
    if (chartType != 'Select') {
      if (chartType.toLowerCase().indexOf('map') > -1 || chartType.toLowerCase().indexOf('combo') > -1 || chartType.toLowerCase().indexOf('tacked') > -1 || chartType.toLowerCase().indexOf('area') > -1) {
        if (this.selectedAxis == 'Select' || this.selectedLegend == 'Select' || this.selectedValue == 'Select') {
          bootbox.alert("Please Select the Valid Chart Configurations");
          return false;
        }
        if ((this.selectedLegend.toLowerCase() == this.selectedValue.toLowerCase()) && (chartType.indexOf('combo') > -1)) {
          bootbox.alert("Legend and Value dropdown values should not be the same");
          return false;
        }
        if (this.selectedAxis.toLowerCase() == this.selectedLegend.toLowerCase()) {
          bootbox.alert("Axis and Legend dropdown values should not be the same");
          return false;
        }
      }
      else {
        if (this.selectedAxis == 'Select' || this.selectedValue == 'Select') {
          bootbox.alert("Please Select the Valid Chart Configurations");
          return false;
        }
      }
      if (this.selectedValue.toLowerCase() == 'no items') {
        bootbox.alert("You cannot proceed Preview/Apply Charts");
        return false;
      }
      else {
        return true;
      }
    }
    else if (chartType == 'Select') {
      bootbox.alert("Please Select the Valid Chart Configurations");
      return false;
    }
    else {
      return true;
    }
  }
}
